import * as React from "react";
import { DefaultButton } from "@fluentui/react";
import Header from "./Header";
import HeroList, { HeroListItem } from "./HeroList";
import Progress from "./Progress";

import { useAppContext } from '../MSGraph/AppContext';
import { MsalProvider } from '@azure/msal-react'
import { IPublicClientApplication } from '@azure/msal-browser';
import ProvideAppContext from '../MSGraph/AppContext';
import Welcome from "./Welcome";
import ErrorMessage from "./ErrorMessage";
/* global Word, require */
import AlternateClauseAI from "./AlternateClauseAI";
import AlternateClause from "./AlternateClause";
import Home from "./Home";
import WordAddIn from "./WordAddIn";
export interface AppProps {
  title: string;
  isOfficeInitialized: boolean;
  pca: IPublicClientApplication;
}

export interface AppState {
  listItems: HeroListItem[];
}

export default class App extends React.Component<AppProps, AppState> {
  constructor(props, context) {
    super(props, context);
    this.state = {
      listItems: [],
    };
  }

  componentDidMount() {
    this.setState({
      listItems: [
        {
          icon: "Ribbon",
          primaryText: "Achieve more with Office integration",
        },
        {
          icon: "Unlock",
          primaryText: "Unlock features and functionality",
        },
        {
          icon: "Design",
          primaryText: "Create and visualize like a pro",
        },
      ],
    });
  }

  click = async () => {
    return Word.run(async (context) => {
      /**
       * Insert your Word code here
       */

      // insert a paragraph at the end of the document.
      const paragraph = context.document.body.insertParagraph("Hello World", Word.InsertLocation.end);

      // change the paragraph color to blue.
      paragraph.font.color = "blue";

      await context.sync();
    });
  };

  render() {
    const { title, isOfficeInitialized,pca } = this.props;

    if (!isOfficeInitialized) {
      return (
        <Progress
          title={title}
          logo={require("./../../../assets/logo-filled.png")}
          message="Please sideload your addin to see app body."
        />
      );
    }

    return (
      // <div className="ms-welcome">
      //   <Header logo={require("./../../../assets/logo-filled.png")} title={this.props.title} message="Welcome" />
      //   <HeroList message="Discover what Office Add-ins can do for you today!" items={this.state.listItems}>
      //     <p className="ms-font-l">
      //       Modify the source files, then click <b>Run</b>.
      //     </p>
      //     <DefaultButton className="ms-welcome__action" iconProps={{ iconName: "ChevronRight" }} onClick={this.click}>
      //       Run
      //     </DefaultButton>
      //   </HeroList>
      // </div>
      <MsalProvider instance={pca}>
      <ProvideAppContext>
        {/* <Router>
          <NavBar />
          <Container>
            <ErrorMessage />
            <Routes>
              <Route path="/"
                element={
                  <Welcome />
                } />
              <Route path="/calendar"
                element={
                  <Calendar />
                } />
              <Route path="/newevent"
                element={
                  <NewEvent />
                } />
            </Routes>
          </Container>
        </Router> */}
         <ErrorMessage />
          {/* <Welcome /> */}
          {/* <Home siteURL={""}tokenvalue={""}currentUser={{}}/> */}
          <WordAddIn/>
          {/* <AlternateClauseAI/> */}
      </ProvideAppContext>
    </MsalProvider>
    );
  }
}
